import { render } from "./ImageViewer.vue?vue&type=template&id=3e8a159c&scoped=true&ts=true"
import script from "./ImageViewer.vue?vue&type=script&lang=ts"
export * from "./ImageViewer.vue?vue&type=script&lang=ts"

import "./ImageViewer.vue?vue&type=style&index=0&id=3e8a159c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e8a159c"]])

export default __exports__